import angular from 'angular';
import directivesSimple from './directives-simple';

let DirectivesModule = angular.module('app.shared.directives', [])
  .directive('compareTo', directivesSimple.compareTo)
  .directive('upperCase', directivesSimple.upperCase)
  .directive('providerSideMenu', directivesSimple.providerSideMenu)
  .directive('toolboxFilter', directivesSimple.toolboxFilter)
  .directive('toolboxPagination', directivesSimple.toolboxFilter)
  .directive('ngEnter', directivesSimple.ngEnter)
  .directive('checkStrength', directivesSimple.checkStrength);

export default DirectivesModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/shared/directives/directives.js
 **/